import React from 'react';
import { Button, Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ProductCard = styled(Card)(({ theme }) => ({
  maxWidth: 300,
  margin: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
}));

const ProductImage = styled(CardMedia)({
  paddingTop: '100%', // 1:1 aspect ratio
  backgroundSize: 'contain',
  backgroundColor: '#f5f5f5',
});

const ProductTitle = styled(Typography)({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minHeight: '3.6em', // 2 lines of text
  marginBottom: '8px',
});

const PriceText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 'bold',
  fontSize: '1.2rem',
  margin: '8px 0',
}));

const getSiteFromUrl = (url) => {
  try {
    const domain = new URL(url).hostname;
    if (domain.includes('tmall')) return 'Tmall';
    if (domain.includes('1688')) return '1688';
    return 'Taobao';
  } catch {
    return 'Taobao';
  }
};


const TaobaoProductCard = ({ product, onImport, disabled = false }) => {
  return (
    <ProductCard>
      <ProductImage
        image={product.mainImageUrl || product.pic_url || 'https://via.placeholder.com/300'}
        title={product.multiLanguageInfo?.title || product.title}
      />
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <ProductTitle variant="subtitle1" component="h3">
          {product.multiLanguageInfo?.title || product.title}
        </ProductTitle>

        <Typography variant="caption" sx={{ color: 'text.secondary', mb: 1 }}>
          Source: {getSiteFromUrl(product.detail_url || '')}
        </Typography>

        {product.shopName && (
          <Typography variant="body2" color="text.secondary">
            Seller: {product.shopName}
          </Typography>
        )}

        {product.sales > 0 && (
          <Typography variant="body2" color="text.secondary">
            Sales: {product.sales.toLocaleString()}
          </Typography>
        )}

        <Box sx={{ mt: 'auto' }}>
          <PriceText>
            ¥{product.price || 'N/A'}
            {product.original_price && product.original_price !== product.price && (
              <Typography 
                component="span" 
                sx={{ 
                  textDecoration: 'line-through', 
                  color: 'text.secondary',
                  fontSize: '0.8rem',
                  ml: 1
                }}
              >
                ¥{product.original_price}
              </Typography>
            )}
          </PriceText>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button 
              size="small" 
              color="primary" 
              variant="outlined" 
              href={product.detail_url || '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Taobao
            </Button>
            <Button 
              size="small" 
              color="primary" 
              variant="contained"
              disabled={disabled}
              onClick={() => onImport(product)}
              sx={{
                '&.Mui-disabled': {
                  pointerEvents: 'auto',
                  cursor: 'not-allowed',
                  opacity: 0.7
                }
              }}
            >
              Import
            </Button>
          </Box>
        </Box>
      </CardContent>
    </ProductCard>
  );
};

export default TaobaoProductCard;
